import { useState, useEffect, useCallback } from "react";
import { debounce } from "lodash";
import { fetchPublicProducts } from "../../../../services/public.services";

const useProductList = () => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 8,
    search: "",
    brandId: "",
    categoryId: "",
    isActive: true,
  });
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: 1,
      perPage: +event.target.value,
    }));
  };

  const handleChangePage = useCallback(
    (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
      setPagination((prevPagination) => ({
        ...prevPagination,
        page: page + 1,
      }));
    },
    []
  );

  // eslint-disable-next-line
  const handleOnChangeSearch = useCallback(
    debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      setPagination((prevPagination) => ({
        ...prevPagination,
        search: event.target.value,
      }));
    }, 500),
    []
  );

  const handleFilter = useCallback((key: string, value: string) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      [key]: value,
    }));
  }, []);

  const getList = useCallback(
    async (loader = true) => {
      if (loader) {
        setLoading(true);
      }
      try {
        const result = await fetchPublicProducts(pagination);
        setList(result?.data);
        setTotalCount(result?.totalCount);
        if (loader) {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    },
    [pagination]
  );

  useEffect(() => {
    getList();
  }, [getList, pagination]);

  return {
    loading,
    list,
    totalCount,
    pagination,
    handleChangeRowsPerPage,
    handleChangePage,
    handleOnChangeSearch,
    getList,
    handleFilter,
  };
};

export default useProductList;
